import { OnInit } from '@angular/core';
var SeguimientoInspeccionComponent = /** @class */ (function () {
    function SeguimientoInspeccionComponent() {
    }
    SeguimientoInspeccionComponent.prototype.ngOnInit = function () {
    };
    return SeguimientoInspeccionComponent;
}());
export { SeguimientoInspeccionComponent };
